import { styled } from "./stiches.config";
export const StyledColumn = styled("div", {
  padding: "22px",
  display: "flex",
  width: "49%",
  height: "70vh",
});

export const StyledList = styled("div", {
  backgroundColor: "#E5E5E5",
  borderRadius: 8,
  width: "100%",
  height: "70vh",
});

export const StyledItem = styled("div", {
  backgroundColor: "white",
  borderRadius: 8,
  // height: "83px",
  marginBottom: "29px",
  width: "calc(100% - 16px)",
});

export const StyledItemMain = styled("div", {
  backgroundColor: "white",
  borderRadius: 4,
  padding: "4px 8px",
  width: "calc(100% - 16px)",
  variants: {
    mobile: {
      true: {
        height: "auto",
      },
      false: {
        height: "80px",
      },
    },
  },
  defaultVariants: {
    mobile: false,
  },
});

export const StyledColumns = styled("div", {
  display: "flex",
  width: "100%",
  justifyContent: "space-between",
});

export const initialColumns = {
  sub: {
    id: "sub",
    list: [
      {
        title: "firstName",
        id: 1,
        isRequired: true,
        isShowRequired: false,
        showClose: true,
      },
      {
        title: "lastName",
        id: 3,
        isRequired: true,
        isShowRequired: false,
        showClose: true,
      },
      {
        title: "email",
        id: 10,
        isRequired: true,
        isShowRequired: false,
        showClose: true,
      },
    ],
  },
    main: {
      id: "main",
      list: [
        { title: "primaryPhoneNumber", id: 5, isRequired: false, isShowRequired: true },
        { title: "age", id: 6, isRequired: false, isShowRequired: true },
        { title: "industry", id: 7, isRequired: false, isShowRequired: true },
        {
          title: "designation",
          id: 8,
          isRequired: false,
          isShowRequired: true,
        },
        {
          title: "interactionRate",
          id: 9,
          isRequired: false,
          isShowRequired: true,
        },{
          title: "againIn",
          id: 10,
          isRequired: false,
          isShowRequired: true,
        },{
          title: "customerSupport",
          id: 11,
          isRequired: false,
          isShowRequired: true,
        },{
          title: "product",
          id: 12,
          isRequired: false,
          isShowRequired: true,
        },{
          title: "purchasedFor",
          id: 13,
          isRequired: false,
          isShowRequired: true,
        },
        {
          title: "address",
          id: 14,
          isRequired: false,
          isShowRequired: true,
        },

        // { title: "city", id: 17, isRequired: false, isShowRequired: true },
        // { title: "state", id: 18, isRequired: false, isShowRequired: true },
        // { title: "country", id: 19, isRequired: false, isShowRequired: true },
        // { title: "zipcode", id: 20, isRequired: false, isShowRequired: true },
        // {
        //   title: "description",
        //   id: 21,
        //   isRequired: false,
        //   isShowRequired: true,
        // },
      ],
    },
};